<template>
  <c-container
    padding-size="small"
    class="settings-page"
  >
    <div :style="{ marginBottom: '2rem' }">
      <h2>
        History
      </h2>
      <c-card-item
        v-for="entity in sortedEntities"
        :key="entity.id"
        :clickable="false"
        show-as-card
        :style="{ marginBottom: '1.6rem' }"
      >
        <template #title>
          <div :style="{ wordBreak: 'break-all'}">
            {{ pageUrl(entity) }}
          </div>
        </template>
        <template #subTitle>
          <div :style="{ color: $colors.grey.lighten1 }">
            {{ entity.createdAt.toDate().toLocaleDateString() }} • {{ entity.host }}
          </div>
          <div
            v-if="entity.notionId !== undefined"
            :style="{ fontSize: '12px', marginTop: '1rem' }"
          >
            <c-button
              size="xs"
              outlined
              target="_blank"
              :href="link(entity)"
            >
              <div :style="{ fontSize: '14px', display: 'flex' }">
                Open Notion Page
                <c-icon
                  type="externalLink"
                  size="13"
                  :style="{ marginLeft: '.4rem' }"
                />
              </div>
            </c-button>
          </div>
        </template>
      </c-card-item>
    </div>
  </c-container>
</template>

<script>
import CButton from 'shared/components/CButton.vue';
import CCardItem from 'shared/components/CCardItem.vue';
import CContainer from 'shared/components/CContainer.vue';
import CIcon from 'shared/components/CIcon.vue';
import {
  HISTORY_SERVICE,
  plans,
} from 'shared/constants';
import { inject } from 'vue';

export default {
  name: 'HistoryPage',
  setup() {
    const historySvc = inject(HISTORY_SERVICE);
    return { entities: historySvc.entities };
  },
  components: { CContainer, CButton, CCardItem, CIcon },
  data() {
    return { plans };
  },
  computed: {
    sortedEntities() {
      const e = Object.values(this.entities);
      e.sort((a, b) => b.createdAt - a.createdAt);
      return e;
    },
  },
  methods: {
    pageUrl(entity) {
      if (entity.pageUrl === '') {
        return 'No url available';
      }
      if (entity.pageUrl.length > 200) {
        return `${entity.pageUrl.slice(0, 30)}...${entity.pageUrl.slice(-20)}`;
      }

      return entity.pageUrl;
    },
    link(entity) {
      if (entity.notionId === undefined) {
        return undefined;
      }
      return `https://notion.so/${entity.notionId.replaceAll('-', '')}`;
    },
  },
};
</script>

<style scoped lang="scss" type="text/scss">
</style>
